export default {
  geofenceMarker (state) {
    return state.app.marker
  }
}